module.exports = __webpack_public_path__ + "static/media/icon-catalog-warning.9c476ed0.svg";